// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ECyfX1YVMyXtgHpQ94yl {
  font-size: 32px;
  font-family: var(--font-stack-full-heavy);
  font-weight: 800;
  line-height: 32px;
  height: 32px;
  margin: 2px 0;
}

.PJ5YO43ZTbMnY402lnrS {
  font-size: 14px;
  font-family: var(--font-stack-full-heavy);
  font-weight: 800;
  line-height: 20px;
  height: 20px;
}

.m3k5_zjZVAkMmx4_qV4T {
  font-size: 14px;
  font-family: var(--font-stack-full-regular);
  font-weight: 350;
  line-height: 20px;
  height: 20px;
}

.Cjb2vN1fXfT6mKQVIzra {
  padding: 24px;
  display: flex;
  align-items: flex-start;
}

.LI1OM6zs_jkn98c2qlNI {
  margin-left: 32px;
}

.fwIF0exrVv7ajx4JkYrq {
  font-family: var(--font-stack-full-heavy);
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  text-align: left;
}

.VCBMzoCPAv7VfXSLPD7s {
  font-family: var(--font-stack-full-book);
  font-size: 18px;
  font-weight: 350;
  line-height: 26px;
  text-align: left;
}

.EG8HQHPXXr7_peBluvCg {
  width: 100%;
}

.FDIh53Unr1ywNEzW6Lwi {
  line-height: 20px;
  font-size: 14px;
  font-weight: 350;
  font-family: var(--font-stack-full-book);
  color: var(--grey-color-70);
}

.ORIdgWWo4kGabP5VYDz9 {
  line-height: 28px;
  font-size: 20px;
  font-weight: 800;
  font-family: var(--font-stack-full-heavy);
}

.KCM88JMGb8StGsAUc0wA {
  min-width: 367px;
  border: 1px solid;
  border-radius: 24px;
  border-color: var(--grey-gradient-end-color-10);
  padding: 24px 32px;
  background-color: var(--grey-color-10);
}

.Dws04kiphHY6h6RrKkzn {
  margin-top: 32px;
}

.MaEbFjrV4vpNUkJrLo5D {
  font-family: var(--font-stack-full-heavy);
  font-size: 20px;
  line-height: 28px;
  text-align: left;
}

.rTEKavvXciWOi713_ySs {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
  gap: 24px;
}

.Y4jzyqdUPGn58AKrrYu0 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
}
.Y4jzyqdUPGn58AKrrYu0 .KCM88JMGb8StGsAUc0wA {
  min-width: unset;
  width: 100%;
}

.gbruru1CDym8U9vpj2yg {
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
}

.VIz2xGqH3oW33zSM8SQw {
  border-top: 1px solid;
  border-color: var(--grey-gradient-end-color-10);
  margin: 16px 0;
}

.Fmbj4Mtf_IMT9GL9y2Wl {
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  margin-bottom: 20px;
}
.Fmbj4Mtf_IMT9GL9y2Wl:last-child {
  margin-bottom: 0;
}

.KqiCNN85y3FEYz8hKqCB {
  position: absolute;
  right: 10px;
  margin-top: 15px;
  margin-right: 42px;
}

.di70DydXduyTagQmgwJM {
  display: flex;
  gap: 8px;
  font-size: 20px;
  font-family: var(--font-stack-full-heavy);
  font-weight: 400;
  line-height: 28px;
}

.iOZ5SiGBfX4mJbV6a2p1 {
  color: var(--act-dark);
}`, "",{"version":3,"sources":["webpack://./src/pages/SuccessProfileRole/SuccessProfileRole.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,2CAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wCAAA;EACA,2BAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,+CAAA;EACA,kBAAA;EACA,sCAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACF;AACE;EACE,gBAAA;EACA,WAAA;AACJ;;AAGA;EACE,yCAAA;EACA,eAAA;AAAF;;AAGA;EACE,qBAAA;EACA,+CAAA;EACA,cAAA;AAAF;;AAGA;EACE,wCAAA;EACA,eAAA;EACA,mBAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;AADF;;AAIA;EACE,sBAAA;AADF","sourcesContent":[".secondaryTitle {\n  font-size: 32px;\n  font-family: var(--font-stack-full-heavy);\n  font-weight: 800;\n  line-height: 32px;\n  height: 32px;\n  margin: 2px 0;\n}\n\n.secondaryTitleClientName {\n  font-size: 14px;\n  font-family: var(--font-stack-full-heavy);\n  font-weight: 800;\n  line-height: 20px;\n  height: 20px;\n}\n\n.secondaryTitleTimestamp {\n  font-size: 14px;\n  font-family: var(--font-stack-full-regular);\n  font-weight: 350;\n  line-height: 20px;\n  height: 20px;\n}\n\n.overviewTab {\n  padding: 24px;\n  display: flex;\n  align-items: flex-start;\n}\n\n.overviewTabBody {\n  margin-left: 32px;\n}\n\n.overviewRoleSummaryTitle {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 28px;\n  text-align: left;\n}\n\n.overviewRoleSummaryDescription {\n  font-family: var(--font-stack-full-book);\n  font-size: 18px;\n  font-weight: 350;\n  line-height: 26px;\n  text-align: left;\n}\n\n.overviewRoleSummary {\n  width: 100%;\n}\n\n.summaryTitle {\n  line-height: 20px;\n  font-size: 14px;\n  font-weight: 350;\n  font-family: var(--font-stack-full-book);\n  color: var(--grey-color-70);\n}\n\n.summaryValue {\n  line-height: 28px;\n  font-size: 20px;\n  font-weight: 800;\n  font-family: var(--font-stack-full-heavy);\n}\n\n.overviewSummaryCard {\n  min-width: 367px;\n  border: 1px solid;\n  border-radius: 24px;\n  border-color: var(--grey-gradient-end-color-10);\n  padding: 24px 32px;\n  background-color: var(--grey-color-10);\n}\n\n.breakdown {\n  margin-top: 32px;\n}\n\n.breakdownCardTitle {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 20px;\n  line-height: 28px;\n  text-align: left;\n}\n\n.breakdownCardContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 8px;\n  gap: 24px;\n}\n\n.breakdownCardRow {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 24px;\n\n  .overviewSummaryCard {\n    min-width: unset;\n    width: 100%;\n  }\n}\n\n.breakdownTitle {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n}\n\n.breakdownDivider {\n  border-top: 1px solid;\n  border-color: var(--grey-gradient-end-color-10);\n  margin: 16px 0;\n}\n\n.breakdownBodyItem {\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  margin-bottom: 20px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.downloadMenuWrapper {\n  position: absolute;\n  right: 10px;\n  margin-top: 15px;\n  margin-right: 42px;\n}\n\n.confirmationDialogHeader {\n  display: flex;\n  gap: 8px;\n  font-size: 20px;\n  font-family: var(--font-stack-full-heavy);\n  font-weight: 400;\n  line-height: 28px;\n}\n\n.warningIcon {\n  color: var(--act-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secondaryTitle": `ECyfX1YVMyXtgHpQ94yl`,
	"secondaryTitleClientName": `PJ5YO43ZTbMnY402lnrS`,
	"secondaryTitleTimestamp": `m3k5_zjZVAkMmx4_qV4T`,
	"overviewTab": `Cjb2vN1fXfT6mKQVIzra`,
	"overviewTabBody": `LI1OM6zs_jkn98c2qlNI`,
	"overviewRoleSummaryTitle": `fwIF0exrVv7ajx4JkYrq`,
	"overviewRoleSummaryDescription": `VCBMzoCPAv7VfXSLPD7s`,
	"overviewRoleSummary": `EG8HQHPXXr7_peBluvCg`,
	"summaryTitle": `FDIh53Unr1ywNEzW6Lwi`,
	"summaryValue": `ORIdgWWo4kGabP5VYDz9`,
	"overviewSummaryCard": `KCM88JMGb8StGsAUc0wA`,
	"breakdown": `Dws04kiphHY6h6RrKkzn`,
	"breakdownCardTitle": `MaEbFjrV4vpNUkJrLo5D`,
	"breakdownCardContainer": `rTEKavvXciWOi713_ySs`,
	"breakdownCardRow": `Y4jzyqdUPGn58AKrrYu0`,
	"breakdownTitle": `gbruru1CDym8U9vpj2yg`,
	"breakdownDivider": `VIz2xGqH3oW33zSM8SQw`,
	"breakdownBodyItem": `Fmbj4Mtf_IMT9GL9y2Wl`,
	"downloadMenuWrapper": `KqiCNN85y3FEYz8hKqCB`,
	"confirmationDialogHeader": `di70DydXduyTagQmgwJM`,
	"warningIcon": `iOZ5SiGBfX4mJbV6a2p1`
};
export default ___CSS_LOADER_EXPORT___;
